export namespace UserNs {

    export enum AuthProvider {
        LOCAL= "LOCAL",
        GOOGLE = "GOOGLE",
        FACEBOOK = "FACEBOOK",
        GITHUB = "GITHUB",
        ATLASSIAN = "ATLASSIAN",
        LINKEDIN = "LINKEDIN"
    }

    export const UserRole: {
        value: string,
        accessLevel: number
    } = {
        WS_OWNER: {value: 'OWNER', accessLevel: 200},
        WS_ADMIN: {value: 'ADMIN', accessLevel: 100},
        WS_MEMBER: {value: 'MEMBER', accessLevel: 0},
        MANAGER: {value: 'MANAGER', accessLevel: 20},
        EDITOR: {value: 'EDITOR', accessLevel: 10},
        VIEWER: {value: 'VIEWER', accessLevel: 0},
    }

    export interface UserInfo {
        userName: string,
        firstName: string,
        lastName: string,
        fullName: string,
        fullNameAvatar: string,
        authProvider: AuthProvider,
        avatar: string,
        socialAvatar: string,
        userPlan: string,
        company: string,
        timeZone: string,
        timeZoneOffset: string,
        showOnboarding: boolean
    }

    export interface AuditUser {
        username: string,
        fullName: string,
        fullNameAvatar: string,
        avatar: string,
        socialAvatar: string,
    }

    export interface UserAvatar {
        avatar: string,
        socialAvatar: string,
        fullNameAvatar: string,
        isUrl: boolean
    }

    export interface UserProfile {
        fullName: string,
        avatar: UserAvatar,
        workspaceRole: string
    }

    export interface Theme {
        selectedTheme: 'DARK' | 'LIGHT',
    }

}
